import { render, staticRenderFns } from "./DepotCommandeCommande.vue?vue&type=template&id=2453a80a&scoped=true&"
import script from "./DepotCommandeCommande.vue?vue&type=script&lang=js&"
export * from "./DepotCommandeCommande.vue?vue&type=script&lang=js&"
import style0 from "./DepotCommandeCommande.vue?vue&type=style&index=0&id=2453a80a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2453a80a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardText,VTextField})
